<template>
  <div>
    <div class="page_content share_social_pg not_conf">

      <div class="main_section">
        <div class="container">

          <div class="row justify-content-center top_title">
            <div class="col-12 text-center">
              <h1>Hoera, {{ displayedReward.name }}</h1>

            </div>
            <div class="col-12">
              <div
                class="d-flex flex-column flex-md-row flex-lg-row justify-content-center align-items-center my-0 my-lg-5 my-md-5">
                <h2
                  class="w-100 w-lg-50 w-md-50 text-center text-md-left text-lg-left mr-0 mr-md-2 mr-lg-2">
                  Je {{ displayedReward.name }} zijn aan je Prepaid tegoed<br>
                  toegevoegd en zijn 7 dagen geldig in
                  NL
                </h2>
                <div class="share_social_box w-100 w-lg-50 w-md-50">
                  <img :src="displayedReward.image" alt="">
                  <p>{{ displayedReward.name }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="banners_container">
            <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank">
              <img src="static/img/millen_images/banner_3_desktop.png" alt="Desktop Banner" class="banner_responsive_image banner_desktop_image">
              <img src="static/img/millen_images/banner_3_mobile.png" alt="Mobile Banner" class="banner_responsive_image banner_mobile_image">
            </a>
          </div>

          <div class="row">
            <div class="col-12 text-center">
              <div class="share_socials">
                Je hebt gewonnen!<br> Deel het op social media met #Prepaidsurprise
              </div>
              <div class="d-flex flex-row justify-content-center share_socials_icons">
                <img src="static/img/millen_images/facebook.svg" @click="this.shareBtn">
              </div>
            </div>
          </div>

          <div class="row justify-content-center btn_content air_btn">
            <button v-if="this.getAccessToken && pendingCodes.length>0" type="button"
                    class="black_btn  mr-1"
                    @click.prevent="redirectCustomer(pendingCodes[pendingCodes.length==1?0:1].code)">
              Speel opnieuw
            </button>
            <button type="button" class="black_secondary_btn ml-1"
                    @click="this.isLoggedIn">Terug naar Prepaid Surprise
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import gameFlow from "../common/mixin/gameFlow";

export default {
  name: 'Share',
  data() {
    return {
      displayedReward: [],
      pendingCodes: [],
    }
  },
  mixins: [
    gameFlow
  ],
  computed: {
    ...mapGetters([
      'isPlayGameModalOpen',
      'isLostCodeModalOpen',
      'getLoginResponse',
      'getAccessToken',
      'getSelectedTelcoReward',
      'getTelcoInfo',
      'getHasBeenAwarded',
      'getPhysicalDisplayedPrize',
      'getAccountResponse',
      'getGameFlowState',
    ]),
  },
  mounted() {
      this.retrieveTelcoInfo(this.getSelectedTelcoReward.id)
    // }
    if (this.getAccessToken) {
      // Method that when the page is loading will pull user's open codes if customer is logged in
      this.loadMyAccount()
        .then(() => {
          this.pendingCodes = this.getAccountResponse.pendingCodes
        })
    }
    //End Method
  },
  methods: {
    ...mapMutations([
      'updatePlayGameModal',
      'updateAcceptTermsModal',
      'updateLostCodeModal',
      'updateMsisdn',
      'updateDeliveryDetails',
      'updateSelectedCodeForRedemption'
    ]),
    ...mapActions([
      'loadMyAccount',
      'redeemCode'
    ]),
    // Method implemented for facebook posting
    shareBtn() {
      FB.ui({
        display: 'popup',
        method: 'share',
        href: 'https://prepaidsurprise.odido.nl/',
        hashtag: '#Prepaidsurprise'
      }, function (response) {
        if (response && !response.error_message) {
          router.push({name: 'SocialConfirmation'})
        } else {
          console.log(response.error_message);
        }
      });
    },
    // End method
    // Method that if the user is logged in will direct him to Account page, otherwise will redirect him to Home page
    isLoggedIn() {
      this.resetGameState()
      if (this.getAccessToken) {
        router.push({name: 'Account'})
      } else {
        router.push({name: 'Home'})
      }
    },
    // End Method
    retrievePhysicalInfo() {
      this.displayedReward = this.getPhysicalDisplayedPrize
    },
    retrieveTelcoInfo(rewardId) {
      this.displayedReward = this.getTelcoInfo.find(telco => telco.id === rewardId)
    },
    // Method that takes the last open code of the customer and redirects him to gameOption.js in order to play that code
    redirectCustomer(code) {
      this.resetGameState()
      this.updateSelectedCodeForRedemption(code)
      this.redeemCode()
        .then((response) => {
          this.$store.commit('updateGameFlowState', response.data.currentConversationState)
          if (this.getGameFlowState)
            this.loadInfoFromConversation(response)
          this.gameRouting()
        })
    }
    // End Method
  },
  filters: {
    uppercase: function (v) {
      if (v !== undefined)
        return v.toUpperCase()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Share.vue